<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="top-title-wrap">
                    <div class="main-title">
                        <span>{{ $t('Transaction') }} <span v-if="$route.params.id === 'create'">{{
                                $t('Create')
                            }}</span><span
                            v-else>{{ $t('Edit') }}</span></span>
                    </div>
                </div>
                <box class="aud-box">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="form-group full-width outer">
                                <div class="row">
                                    <div class="col-md-5" hidden>
                                        <label class="group-title">{{ $t('Date') }} <i>*</i></label>
                                        <dspInput
                                            v-validate="'required'"
                                            :errorsBag="errors"
                                            name="createdAt"
                                            :placeholder="$t('Transaction Date')"
                                            :disabled="true"
                                        >
                                        </dspInput>
                                    </div>
                                    <div class="col-md-9">
                                        <label class="group-title">{{ $t('User') }} <i>*</i></label>
                                        <dropdown v-model="selectedUser"
                                                  :showSearch="true"
                                                  :options="users"
                                                  @search="getUsersListDebounce(null,$event)"
                                                  class="wide">

                                            <template v-slot:header="header">
                                                <span>{{
                                                        header.value ? header.value.text : $t('(Select User)')
                                                    }}</span>
                                            </template>
                                            <template v-slot:item="item">
                                                <span>{{ item.option.text }}</span>
                                            </template>
                                        </dropdown>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group outer full-width">
                                <div class="row">
                                    <div class="col-md-5">
                                        <label class="group-title">{{ $t('Amount') }} <i>*</i></label>
                                        <dspInput
                                            v-model="transaction.transactionAmount"
                                            v-validate="'required'"
                                            :errorsBag="errors"
                                            name="transactionAmount"
                                            :placeholder="$t('Transaction Date')">
                                        </dspInput>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="group-title">{{ $t('Method') }} <i>*</i></label>
                                        <dspSelect
                                            v-model="transaction.method"
                                            :options="methods"
                                            v-validate="'required'"
                                            :errorsBag="errors"
                                            name="method"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group outer full-width">
                                <div class="row">
                                    <div class="col-md-9">
                                        <label class="group-title">{{ $t('Description') }}</label>
                                        <dspInput
                                            v-model="transaction.notes"
                                            v-validate="''"
                                            :errorsBag="errors"
                                            name="notes"
                                            :placeholder="$t('Select or type description...')">
                                        </dspInput>
                                    </div>
                                    <div class="col-md-9 mb-10 mt-10">
                                        <label>Quick entry values</label>
                                    </div>
                                    <div class="col-md-9">
                                        <dspButton @click="addDescriptionValue('deposit funds')" class="mr-2 button active">
                                            {{ $t('deposit funds') }}
                                        </dspButton>
                                        <dspButton @click="addDescriptionValue('refund funds')" class="mr-2 button active">
                                            {{ $t('refund funds') }}
                                        </dspButton>
                                        <dspButton @click="addDescriptionValue('transfer from')" class="mr-2 button active">
                                            {{ $t('transfer from') }}
                                        </dspButton>
                                        <dspButton @click="addDescriptionValue('transfer to')" class="mr-2 button active">
                                            {{ $t('transfer to') }}
                                        </dspButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-wrap">
                        <a @click="$router.go(-1)"
                           class="button plain">{{ $t('Cancel') }}</a>
                        <dspButton :disabled="saveBtnDiasbled"
                                   @click="createOrEdit"
                                   class="primary">{{ $t('Save') }}
                        </dspButton>
                    </div>
                </box>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import {floatFormatter} from "../../lib/numberFormatters";
import searchUsersMixin from "@/lib/searchUsers";
import sudoUser from "@/lib/sudoUser";

export default {
    name: 'admin-transaction',
    mixins: [searchUsersMixin, sudoUser],
    data() {
        return {
            users: [],
            selectedUser: null,
            transaction: {
                createdAt: moment().format('YYYY-MM-DD hh:mm'),
                transactionAmount: 0,
                userId: null,
                method: 0,
                notes: ''
            },
            methods: [
                {value: 0, text: this.$t('Account Balance')},
                {value: 1, text: this.$t('PayPal')},
                {value: 2, text: this.$t('Credit Card')},
                {value: 3, text: this.$t('Payments')},
                {value: 4, text: this.$t('Wire Transfer')},
                {value: 5, text: this.$t('Bank of America')}
            ],
            saveBtnDiasbled: false,
        }
    },


    created() {
        if (!this.$auth.checkFinanceAdmin()) {
            this.$router.push({name: 'admin.dashboard'});
        }

        this.getUsersList(null, null);

        if (this.$route.params.id !== 'create') {
            this.$axios.get('/admin/transactions/' + this.$route.params.id)
                .then(resp => {
                    this.transaction = resp.data.data;
                    this.transaction.transactionAmount = floatFormatter(this.transaction.transactionAmount)
                }).catch(() => {
                this.$notify.error(this.$t('Service Error'))
            })
        }
    },

    methods: {
        addDescriptionValue(value) {
            const values = [
                ...new Set((this.transaction.notes || '')
                    .split(',')
                    .map(item => item.trim())
                    .filter(item => !!item))
            ];

            if (!values.includes(value)) {
                values.push(value);
            }

            this.transaction.notes = values.join(',');
        },
        createOrEdit() {
            if (this.selectedUser) {
                this.transaction.userId = this.selectedUser.value;
            }

            let method = 'patch';
            let url = '/admin/transactions/' + this.$route.params.id;

            if (this.$route.params.id === 'create') {
                method = 'post';
                url = '/admin/transactions';
            }

            this.$validator.errors.clear();
            this.saveBtnDiasbled = true;
            this.$axios[method](url, this.transaction).then(
                res => {
                    this.$notify.info(res.data.message);
                    setTimeout(() => {
                        this.$router.push(
                            {name: 'admin.transactions'},
                            () => {
                                this.saveBtnDiasbled = false;
                            }
                        );
                    }, 1000);
                }
            ).catch(error => {
                this.$backendErrors(error, this.$t('Error save transaction: '), this.$validator);
                this.saveBtnDiasbled = false;
            })

        }
    }

}
</script>

<style lang="scss">
.automated-dates {
    .mdrp-root {
        width: 100%;
    }
}
</style>
